'use strict';

import React, { Component } from 'react';
import globalConfig from '../../settings/config';

class MapOverlay extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isMapLoaded, loadMapFailed, haveResults } = this.props;
    let ovarlayClasses = 'overlay';
    if (!loadMapFailed) {
      //Please don't remove the following line. Check Dev Dairy for more info
      //ovarlayClasses += isMapLoaded ? '' : ' overlay--isloading';
      //ovarlayClasses = isMapLoaded;
    } else {
      ovarlayClasses += ' overlay--error';
    }

    if (!haveResults) {
      ovarlayClasses += ' overlay--no-results';
    }

    return (
      <div className={ovarlayClasses}>
        {this.props.loadMapFailed && (<p className="overlay--error-msg">{globalConfig.messages.loadDataFailed}</p>)}
        {!haveResults && (<p className="overlay--error-msg">{globalConfig.messages.noResultsOverlayMsg}</p>)}
      </div>
    );
  }
}

export default MapOverlay;